import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submit"];
  static values = { name: String };

  validate() {
    this.submitTarget.disabled = this.inputTarget.value !== this.nameValue;
  }

  focus() {
    this.inputTarget.focus();
  }
}
